/**
 * Minimal PIM catalog seed for fixture SKUs — reference src/data/products.ts.
 * Used by PMA triage sidebar dimensions and attribute baseline until live PIM wiring.
 */
export interface PimProduct {
  sku: string
  label: string
  category: string
  width: number | null
  height: number | null
  base_substrate?: string
  marketplace?: string
  current_price: number
  uin?: string | null
}

const RECORDS: PimProduct[] = [
  {
    sku: 'AMZAVL0940',
    label: 'Connect At Amazon Round Wall Vinyl | 36x36',
    category: 'Wall Graphics',
    width: 36,
    height: 36,
    base_substrate: 'VINYL_CAST',
    marketplace: 'Amazon',
    current_price: 320.28,
    uin: null,
  },
  {
    sku: 'GEOAVL2264',
    label: 'Own The All Orange Vinyl 8" | 63.4x8.6',
    category: 'Vinyl',
    width: 63.4,
    height: 8.6,
    base_substrate: 'VINYL_CAST',
    marketplace: 'Geodis',
    current_price: 103.02,
    uin: null,
  },
  {
    sku: 'AMZACM4011',
    label: 'Caribbean Connection At Amazon ACM TV Box | 41.25x90',
    category: 'ACM',
    width: 41.25,
    height: 90,
    base_substrate: 'ACM_3MM_WHITE (41.25x90) Front',
    marketplace: 'Amazon',
    current_price: 3558.68,
    uin: null,
  },
]

const BY_SKU = new Map(RECORDS.map((r) => [r.sku, r]))

export function getProduct(sku: string): PimProduct | undefined {
  return BY_SKU.get(sku)
}
